import React from 'react';
import styled from 'styled-components';

export const StyledConfirmationBoxLogo = styled(({ alt, ...rest }) => (
  <img alt={alt} {...rest} />
))``;
